<template>
  <Transition name="icp-picker">
    <div v-if="show" class="icp-picker">
      <div class="icp-picker__header">
        <span>Select ICP — AI {{ modeLabel }}</span>
        <button class="icp-picker__close" @click="$emit('dismiss')">
          <Icon icon="mdi:close" width="16" height="16" />
        </button>
      </div>
      <div class="icp-picker__list">
        <button
          v-for="icp in icps"
          :key="icp.id"
          class="icp-picker__option"
          @click="$emit('select', icp.id)"
        >
          <span class="icp-picker__option-name">{{ icp.name }}</span>
          <span v-if="icp.isDefault" class="icp-picker__default-badge">Default</span>
        </button>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { computed } from "vue";
import { Icon } from "@iconify/vue";

const props = defineProps({
  show: { type: Boolean, default: false },
  mode: { type: String, default: "reply" }, // 'reply' | 'followup' | 'compose'
  icps: { type: Array, default: () => [] },
});

const modeLabel = computed(() => {
  if (props.mode === "followup") return "Follow-up";
  if (props.mode === "compose") return "Compose";
  return "Reply";
});

defineEmits(["select", "dismiss"]);
</script>

<style scoped>
.icp-picker {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.icp-picker__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-bottom: 1px solid #f3f4f6;
  font-size: 12px;
  font-weight: 600;
  color: #111827;
}

.icp-picker__close {
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  padding: 2px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.icp-picker__close:hover {
  background: #f3f4f6;
}

.icp-picker__list {
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.icp-picker__option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: none;
  background: none;
  border-radius: 7px;
  cursor: pointer;
  width: 100%;
  text-align: left;
  font-size: 13px;
  color: #111827;
  transition: background 0.15s;
}

.icp-picker__option:hover {
  background: #f3f4f6;
}

.icp-picker__option-name {
  flex: 1;
}

.icp-picker__default-badge {
  font-size: 11px;
  padding: 1px 7px;
  border-radius: 10px;
  background: #eff6ff;
  color: #3b82f6;
  font-weight: 500;
}

.icp-picker-enter-active,
.icp-picker-leave-active {
  transition:
    opacity 0.15s,
    transform 0.15s;
}

.icp-picker-enter-from,
.icp-picker-leave-to {
  opacity: 0;
  transform: translateY(6px);
}
</style>
